import styled from 'styled-components';
export const TopBar = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-2) var(--spacing-1) var(--spacing-2) var(--spacing-2);
  gap: var(--spacing-1);
  box-sizing: border-box;
  background-color: var(--color-neutral-70);
  border-bottom: 1px solid var(--color-neutral-100);
`;
export const ButtonWrapper = styled.button `
  align-items: center;
  background-color: var(--color-neutral-70);
  border: none;
  border-radius: var(--border-radius-circle);
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  outline: none;
  padding: 5px;

  :focus {
    outline: var(--border-width-thin) solid var(--color-neutral-130);
    border-radius: var(--border-radius-pill);
  }
`;
